import { Button as MuiButton, Stack } from '@mui/material'
import EventOutlinedIcon from '@mui/icons-material/EventOutlined'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined'
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined'
import MobileEmptyStateCard from '../../../components/MobileEmptyStateCard'
import { MobileExpandableDetailCard } from '../../../components/mobile'
import { effectiveLocationStr } from '../../../helpers/utils'
import { formatTimetoHHmm } from '../../../helpers/utils'
import { REPORT_MOBILE_OUTLINED_ACTION_BUTTON_SX } from './styles/reportMobileActionButtonSx'
import dayjs from 'dayjs'

export default function TimestampControlMobileContent({
  timestampData = [],
  expandedTimestampKey,
  onToggleExpand,
  onOpenLocation
}) {
  if (timestampData.length === 0) {
    return (
      <MobileEmptyStateCard
        icon={<ScheduleOutlinedIcon fontSize="small" />}
        title="No hay registros de horario"
        description="Cuando existan visitas en el rango seleccionado, aparecerán aquí con su detalle."
      />
    )
  }

  return (
    <Stack spacing={1.5} sx={{ width: '100%', minWidth: 0 }}>
      {timestampData.map((model) => {
        const timestampKey = `${model.client_name}-${model.visited_date}-${model.start_visit_time}`
        const endTimeLabel =
          model.status === 'completed' ? formatTimetoHHmm(model.end_visit_time) : 'En curso'
        const locationButton = (
          <MuiButton
            variant="outlined"
            size="small"
            fullWidth
            startIcon={<LocationOnOutlinedIcon fontSize="small" />}
            type="button"
            onClick={(event) => onOpenLocation(model, event)}
            sx={REPORT_MOBILE_OUTLINED_ACTION_BUTTON_SX}
          >
            Ver ubicación
          </MuiButton>
        )

        return (
          <MobileExpandableDetailCard
            key={timestampKey}
            code={model.client_name}
            bodyFontSize={14}
            codeFontSize={14}
            summaryValueFontSize={14}
            expanded={expandedTimestampKey === timestampKey}
            onToggleExpand={() => onToggleExpand(timestampKey)}
            summaryRows={[
              {
                label: 'Fecha',
                value: dayjs(model.visited_date).format('DD/MM/YYYY')
              },
              {
                label: 'Hora de inicio',
                value: formatTimetoHHmm(model.start_visit_time)
              },
              {
                label: 'Estado / fin',
                value: endTimeLabel
              }
            ]}
            detailRows={[
              {
                icon: <ScheduleOutlinedIcon fontSize="small" />,
                label: 'Duración de visita',
                value: model.status === 'completed' ? model.visit_duration : '-'
              },
              {
                icon: <TaskAltOutlinedIcon fontSize="small" />,
                label: 'Dentro de geocerca',
                value:
                  model.effective_location != null
                    ? effectiveLocationStr(
                        model.effective_location,
                        model.client_latitude,
                        model.start_latitude
                      )
                    : 'N/A'
              },
              {
                icon: <EventOutlinedIcon fontSize="small" />,
                label: 'Hora de finalización',
                value: model.status === 'completed' ? formatTimetoHHmm(model.end_visit_time) : '-',
                fullWidthFooter: locationButton
              }
            ]}
            lighterDetailDividers
          />
        )
      })}
    </Stack>
  )
}
